import React from 'react'
import { Card } from 'react-bootstrap'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import * as s from './EliminatorWinners.scss'

const EliminatorWinnerCardHeader = ({ seasonName, hasWinner, hasTie, winners = [] }) => (
    <Card.Header className={s.header}>
        <FontAwesomeIcon name='trophy' className={s.icon} size='2x' />
        <h4 className={s.seasonName}>{seasonName}</h4>
        <div className={s.resultLabel}>
            {hasTie ? `${winners.length}-way tie` : hasWinner ? 'Winner' : 'In progress'}
        </div>
    </Card.Header>
)

export default EliminatorWinnerCardHeader
